// Utility to map test codes to names
export const getTestNameFromCode = (testCode, testConfig) => {
  if (!testConfig || !testCode) return testCode;
  
  // Search through all categories to find the test
  for (const tests of Object.values(testConfig.availableTests)) {
    const test = tests.find(t => t.code === testCode);
    if (test) return test.name;
  }
  
  // If not found, return the code as fallback
  return testCode;
};

// Utility to map multiple test codes to names
export const getTestNamesFromCodes = (testCodes, testConfig) => {
  if (!testCodes || !Array.isArray(testCodes)) return [];
  return testCodes.map(code => getTestNameFromCode(code, testConfig));
};